import { number, object, string } from "yup";

/*
  validate lineId is not empty string,purpose is either 0 or 1, roomNumber is not empty string, date is not empty string and is in format of a html date input, and is later than current date, hour is a number greater than 0, and can either end in .0 or .5
*/
const postReservationSchema = object().shape({
  lineId: string().required("請填寫姓名"),
  purpose: number().oneOf([0, 1], "請選擇正確的目的").required("請填寫目的"),
  roomNumber: string().required("請填寫房號"),
  date: string()
    .required("請填寫日期")
    .test("date", "請填寫未來十四天的日期", function (value) {
      // later than current date
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      // between today and 14 days after
      if (
        new Date(value) < today ||
        new Date(value) > new Date(today.getTime() + 14 * 24 * 60 * 60 * 1000)
      ) {
        return false;
      }
      return true;
    }),
  hour: number()
    .required("請填寫時間")
    .test("hour", "請填寫正確的時間", function (value) {
      if (
        Number(value) < 0 ||
        Number(value) > 24 ||
        Number(value) % 0.5 !== 0
      ) {
        return false;
      }
      return true;
    }),
});

export { postReservationSchema };
